'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publishOfficeHoursMessage = undefined;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _buildUnpublishedMessage = require('conversations-schema/factories/PubNubMessageFactory/buildUnpublishedMessage');

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _SenderIds = require('conversations-schema/constants/SenderIds');

var _OfficeHoursMessageMetadata = require('conversations-schema/records/PubNubMessageMetadata/OfficeHoursMessageMetadata');

var _OfficeHoursMessageMetadata2 = _interopRequireDefault(_OfficeHoursMessageMetadata);

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _getOfficeHoursStartTime = require('conversations-schema/availability/operators/getOfficeHoursStartTime');

var _getThreadByChannel = require('../../threads/selectors/getThreadByChannel');

var _publishMessageToConversation = require('../../actions/PublishActions/publishMessageToConversation');

var _getWidgetAvailabilityOptions = require('../../availability/selectors/getWidgetAvailabilityOptions');

var _trackInteraction = require('../../usage-tracking/actions/trackInteraction');

var _getAvailabilityOfficeHoursWillReturnMessage = require('../../availability/selectors/getAvailabilityOfficeHoursWillReturnMessage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var publishOfficeHoursMessage = exports.publishOfficeHoursMessage = function publishOfficeHoursMessage(_ref) {
  var channel = _ref.channel;
  return function (dispatch, getState) {
    var threadId = (0, _pipe2.default)(function (state) {
      return (0, _getThreadByChannel.getThreadByChannel)(state, { channel: channel });
    }, _threadGetters.getThreadId)(getState());

    var message = (0, _buildUnpublishedMessage.buildUnpublishedMessage)({
      descriptor: {
        channel: channel
      },
      metadata: new _OfficeHoursMessageMetadata2.default({
        text: (0, _getAvailabilityOfficeHoursWillReturnMessage.getAvailabilityOfficeHoursWillReturnMessage)(getState()),
        officeHoursStartTime: (0, _pipe2.default)(_getWidgetAvailabilityOptions.getWidgetAvailabilityOptions, _getOfficeHoursStartTime.getOfficeHoursStartTime)(getState())
      }),
      senderId: _SenderIds.SYSTEM_ID,
      senderType: _senderTypes.SYSTEM,
      threadId: threadId
    });

    dispatch((0, _publishMessageToConversation.publishMessageToConversation)({ channel: channel, message: message }));

    dispatch((0, _trackInteraction.trackInteraction)('widget-interaction', {
      action: 'view return time'
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/office-hours/actions/publishOfficeHoursMessage.js
// module id = 393
// module chunks = 2 3